import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import styles from './TableList.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip, cellWidth, priceFenToYuanCell } from '@/components/TableCell';
import ButtonPerssion from '@/routes/ButtonPerssion';

class TableList extends React.Component {

    _takeColumns = () => ([
        {
            title: '手机号码',
            dataIndex: 'riderTel',
            key: 'riderTel',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '姓名',
            dataIndex: 'riderName',
            key: 'riderName',
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '退回金额（元）',
            dataIndex: 'refundFee',
            key: 'refundFee',
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '押金账户',
            dataIndex: 'settleAccountId',
            key: 'settleAccountId',
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '审核状态',
            dataIndex: 'statusName',
            key: 'statusName',
            width: cellWidth.small,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '退款状态',
            dataIndex: 'refundStatusName',
            key: 'refundStatusName',
            width: cellWidth.small,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '提交时间',
            dataIndex: 'gmtCreate',
            key: 'gmtCreate',
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'groupId',
            width: "150px",
            key: 'action',
            align: 'center',
            fixed: 'right',
            render: (text, item) => this._renderActionCell(text, item)
        }
    ]);

    _renderActionCell = (key, item) => {
        const { tableAction } = this.props;

        let items = [
            item.status === 'COMMIT' && <ButtonPerssion code='finance/paymanage/tbzj/sh'><div className={styles.item} onClick={() => tableAction(key, 'audit', item)}>审核</div></ButtonPerssion> ,
            item.status === 'COMPLETE' && item.refundStatus.indexOf('TODO') >=0 && <ButtonPerssion code='finance/paymanage/tbzj/tk'><div className={styles.item} onClick={() => tableAction(key, 'refund', item)}>退款</div></ButtonPerssion>, 
            item.status === 'COMPLETE' && item.refundStatus.indexOf('TODO') >=0 && <ButtonPerssion code='finance/paymanage/tbzj/tk'><div className={styles.item} onClick={() => tableAction(key, 'rejectRefund', item)}>拒退</div></ButtonPerssion> 
        ];

        return (
            <div className={styles.action}>
                <ButtonPerssion code='finance/paymanage/tbzj/xq'><div className={styles.item} onClick={() => tableAction(key, 'detail', item)}>详情</div></ButtonPerssion>
                {item.status ==='REVOKE' ? null : items}
            </div>
        );
    }


    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record) => record.id}
                    columns={this._takeColumns()}
                    dataSource={dataList}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableList.propTypes = {
    showAudit: PropTypes.bool,
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default TableList;